import styled from "styled-components"
import media from "styled-media-query";
import backgroundSolutions from "../../images/backgroundSolutions.png"
import backgroundPattern from "../../images/backgroundPattern.png"

import backgroundOurSolutions from "../../images/background-our-solutions.png"


export const Wrapper = styled.div`
    margin-top: 100px;
    ${media.lessThan("small")`
      margin-top: 50px;
    `}
    ${media.between("medium", "large")`;
      margin: 50px 50px;
    `}
`

export const WrapperTitleSolutions = styled.div`
  margin-bottom: 100px;
  ${media.lessThan("small")`
    margin: 0 30px;
      .img-Our {
        display: none!important;
      }
    `}
`

export const TitleSolutions = styled.h3`
  margin-top: 20px;
  margin-bottom: 80px;
  font-size: 40px;
  font-family: "Josefin Sans", sans-serif;
  color: ${props => props.theme.colors.subtitle};
  font-weight: 600;
  line-height: 20px;
  text-align: center;

  ${media.lessThan("small")`
    text-align: center;
    font-size: 25px;
    margin-bottom: 20px;
    > hr {
    width: 180px;
    margin-left: 2px;
    margin-top: 1px;
    opacity: 0.7;
  }
  `}
  ${media.between("medium", "large")`
    font-size: 35px;
    margin-bottom: 40px;
    > hr {
    width:230px;
    margin-left: 2px;
    margin-top: 1px;
    opacity: 0.7;
    }
    `}
`

export const Card = styled.div`
  width: 279px;
  height: 314px;
  background-color: white;
  box-shadow: 0px 20px 20px #7682b72e;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
    ${media.lessThan("small")`
      width: 100%;
      height: 250px;
    `}
    &:before{
      width: 280px;
      height: 320px;
    content: "";
    background-image: url(${backgroundPattern});
    background-repeat: no-repeat;
    position: absolute;
    z-index: -1;
    margin: -15px 80px 0 0;
    ${media.lessThan("small")`
    background-image: none;
    `}
  }
`

export const Subtitle = styled.p`
  font-size: 25px;
  font-family: "Josefin Sans", sans-serif;
  font-weight: bold;
  line-height: 40px;
    ${media.lessThan("small")`
    font-size: 23px;
    > br {
      display: none;
    }

    `}
`
export const Button = styled.button`
  width: 110px;
  height: 39px;
  background-color: ${props => props.theme.colors.info};
  color: ${props => props.theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: space-around;
  transition: color 0.5s;
  transition: background-color 0.5s;
  > svg {
    width: 16px;
  }
  &:hover {
    color: ${props => props.theme.colors.footer};
    background-color: ${props => props.theme.colors.primary};
  }

    ${media.lessThan("small")`
      width: 210px;
      font-size: 20px;
    `}
`
export const Packages = styled.div`
  margin-top: 150px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`
export const PackageTitle = styled.h4`
  margin: 30px auto;
  font-size: 14px;
  font-family: "Josefin Sans", sans-serif;
  font-weight: 400;
  color: ${props => props.theme.colors.titlePrimary};
`
export const PackageSubtitle = styled.div`
  font-size: 40px;
  font-family: "Josefin Sans", sans-serif;
  color: ${props => props.theme.colors.subtitle};
  font-weight: 600;
  line-height: 20px;
  > hr {
    width: 460px;
    border: 0;
    height: 0;
    box-shadow: 0 0 5px 1px ${props => props.theme.colors.success};
    opacity: 0.7;
    margin-top: 1px;
  }
  ${media.lessThan("small")`
    text-align: center;
    font-size: 25px;
    > hr {
    width: 290px;
    margin-left: 2px;
    margin-top: 1px;
    opacity: 0.7;
  }
  `}
  ${media.between("medium", "large")`
    font-size: 35px;
    > hr {
    width:400px;
    margin-left: 2px;
    margin-top: 1px;
    opacity: 0.7;
    }
    `}
`

export const WrapperPlans = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 383px;
  grid-template-areas: "essencial flexplan autopilot";
  margin-top: 70px;
  justify-items: center;
  ${media.lessThan("small")`
    display: block;
  `}
  ${media.between("medium", "large")`
  overflow-x: scroll;
    grid-gap: 30px;

    `}
`

export const EssencialCard = styled.div`
  grid-area: essencial;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 334px;
  height: 300px;
  background-color: white;
  box-shadow: 0px 20px 20px #7682b72e;

  > div {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    > svg {
      width: 70px;
      margin-right: 20px;
    }
  }

  ${media.lessThan("small")`
    width: 100%;
  `}

`
export const FlexCard = styled.div`
  grid-area: flexplan;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 334px;
  height: 300px;
  background-color: white;
  box-shadow: 0px 20px 20px #7682b72e;

  > div {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;

    > svg {
      width: 70px;
      margin-right: 20px;
    }
  }
  ${media.lessThan("small")`
    width: 100%;
  `}
`

export const AutoPilotCard = styled.div`
  grid-area: autopilot;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 334px;
  height: 300px;
  background-color: white;
  box-shadow: 0px 20px 20px #7682b72e;

  > div {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;

    > svg {
      width: 70px;
      margin-right: 20px;
    }
  }
  ${media.lessThan("small")`
    width: 100%;
  `}
`
export const PlanTitle = styled.h4`
  font-size: 25px;
  font-family: "Josefin Sans", sans-serif;
`
export const PlanList = styled.p`
  font-size: 16px;
  font-family: "Josefin Sans", sans-serif;
  color: ${props => props.theme.colors.grey};
`
export const WrapperBackground = styled.div`
  z-index: -1;
  background-image: url(${backgroundSolutions});
  background-repeat: no-repeat;
  background-size: contain;
  //background-attachment: fixed;
  background-position: right;

  ${media.lessThan("small")`
    background-image: none;
  `}

  ${media.between("medium", "large")`;
    background-image: none;
    `}

`

/// New Area

export const WrapperOurSolutions = styled.section`
  height: 800px;
  background-image: url(${backgroundOurSolutions});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
`

export const TitleOurSolutions = styled.h2`
  font-size: 40px;
  font-family: "Josefin Sans",sans-serif;
  color: #455A64;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
`

export const Container = styled.div`
  margin-top: 10px;
  margin-bottom: 100px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 700px;
  grid-template-areas: "accordion image";
`

export const Content = styled.div`
  grid-area: "accordion";
  h3 {
    font-size: 40px;
    font-family: "Josefin Sans",sans-serif;
    color: #455A64;
    font-weight: 600;
    text-align: center;
  }
`
export const Image = styled.div`
  grid-area: "image";
  margin: 80px auto;
`